export const calculateCoverageLevel = (tags: string[] = []): number => {
  let coverageLevel = 1;

  const hasSpouse = tags.some((tag) => tag.startsWith('spouse'));
  const dependentCount = tags.filter((tag) => tag.startsWith('dependent')).length;

  if (hasSpouse && dependentCount > 0) {
    return 4; // Family
  }
  if (hasSpouse) {
    return 2; // Primary + Spouse
  }
  if (dependentCount > 0) {
    return 3; // Primary + Dependents
  }

  return coverageLevel; // Individual
};
